import React, {useEffect} from 'react';
import classes from "./admin.module.css";
import { useSearchParams } from 'react-router-dom';
import {setCookie} from "../../../utils/fun_cookie";
import {getServersAPI} from "./api";

const Admin = () => {
    const [searchParams] = useSearchParams();

    useEffect(()=>{
        const query = searchParams.get('key');
        if(query){
            setCookie('key', query)
        }
    },[])

    useEffect(()=>{
        const getServers = async ()=>{
            const res = await getServersAPI()
            if(res){
                window.location.href='/admin/servers'
            }
        }
        getServers()
    },[])

    return (
        <div>

        </div>
    );
};

export default Admin;